<template>
  <div class="asm-calculator" v-if="line">
    <b-container>
      <b-row>
        <b-col class="my-4">
          <b-row class="my-3">
            <b-col lg="12" md="12">
              <div class="mb-4 d-flex asm-calculator__header">
          <span>
            <h1 class="asm-calculator__headline">
              {{ $t('message.profitabilityOfAerocreteProduction') }}
            </h1>
          </span>
                <span class="ml-auto">
            <button-reset @click="reset" class="mr-2"/>
            <button-save-p-d-f @click="toPDF"/>
          </span>
              </div>
              <!-- Выбор линии SELECT -->

              <div class="line-chooser">
                <b-row>
                  <b-col lg="4" md="12">
                    <b-form-select
                      :options="lineSelectOptions"
                      :value="currentLine"
                      @input="selectLine"
                    />
                  </b-col>
                  <b-col lg="5" md="12">
                    <p class="mb-3">
                      <a :href="`https://asm.ru/produkciya/${line.slug.toLowerCase()}`"
                         class="asm-calculator__link"
                         tabindex="-1" target="_blank">
                        {{ $t('message.goToDescription') }} {{ line.name }}
                      </a>
                    </p>
                  </b-col>
                  <b-col class="text-right" lg="3" md="12">
                    <div class="currency-select">
                      <b-dropdown
                        menu-class="text-right"
                        right
                        variant="currency"
                      >
                        <template v-slot:button-content>
                          {{ $t('message.currency') }}:&nbsp;<span class="mx-1">{{ currency.symbol }}</span>
                        </template>
                        <b-dropdown-item
                          :key="cur.code" @click.prevent="selectCurrency(cur.code)"
                          href="#"
                          v-for="cur in currencies"
                        >{{ cur.symbol }}&nbsp;{{ cur.name }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col class="asm-calculator__column" lg="4" md="12">
              <div class="asm-calculator__production-line">
                <capability-chooser
                  :max="line.capability"
                  class="asm-calculator__production-line-capability"
                  v-model.number="realCapability"
                />
                <period-chooser
                  :max="30"
                  class="asm-calculator__production-line-period"
                  v-model.number="period"
                />
              </div>
              <table class="result-table">
                <tbody>
                <tr>
                  <td class="result-table__head-col result-table__head-col--super" colspan="2">
                    {{ $t('message.profitabilityBasedOn', [1]) }}
                  </td>
                </tr>
                <tr>
                  <td class="result-table__col result-table__col--label">{{ $t('message.sellPrice') }}</td>
                  <td class="result-table__col result-table__col--right">
                    <price-input
                      :currency="currency"
                      :max="localPrice.max"
                      :min="localPrice.min"
                      :step="localPrice.step"
                      hideChange
                      len="2"
                      v-model.number="realPrice"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="result-table__col result-table__col--label">{{ $t('message.costPrice') }}</td>
                  <td class="result-table__col result-table__col--right">
                    <price :currency="currency" :num="cost" size="sm"/>
                  </td>
                </tr>
                <tr>
                  <td class="result-table__col result-table__col--label">{{ $t('message.profit') }}</td>
                  <td class="result-table__col result-table__col--right">
                    <price :currency="currency" :num="profit" size="sm" />
                  </td>
                </tr>
                <tr>
                  <td class="result-table__col">
                    {{ $t('message.volumeOfProduction') }}
                  </td>
                  <td class="result-table__col result-table__col--right">
                    <span class="nobr">{{ capability }}<span class="measure">{{ $t('measure.m3') }}</span></span>

                  </td>
                </tr>
                <tr>
                  <td class="result-table__col result-table__col--label-result">
                    <p class="mb-0">
                      {{ $t('message.profit') }}
                    </p>
                  </td>
                  <td class="result-table__col result-table__col--label-result">
                    <price :currency="currency" :num="capability * profit" hideChange size="xl"/>
                  </td>
                </tr>
                </tbody>
              </table>

            </b-col>


            <b-col class="mt-5 mt-lg-0" lg="8" md="12">
              <div class="asm-calculator__result">
                <table class="asm-calculator__result-table result-table">
                  <colgroup>
                    <col class="result-table__col--left">
                    <col>
                    <col class="result-table__col--recipe">
                    <col>
                    <col class="result-table__col--recipe">
                    <col>
                  </colgroup>
                  <thead v-if="showRecipe">
                  <tr class="result-table__row">
                    <th colspan="4" style="padding: 0 0.5em">
                      <!-- Рецепт газобетона SELECT -->
                      <b-form-select :options="recipes | toOptions" v-model="currentRecipe"/>
                    </th>
                    <th colspan="3"/>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="result-table__row">
                    <th class="result-table__head-col result-table__head-col--super" colspan="4">
                      {{ $t('message.spendsBasedOn', [1]) }}
                    </th>
                    <th class="result-table__head-col result-table__head-col--result" colspan="2">
                      {{ $t('message.needsFor', { period: $tc('plural.day', period)}) }}
                    </th>
                  </tr>
                  <tr :key="ing.id" v-for="ing in result.ingredients">
                    <td class="result-table__col result-table__col--left result-table__col--label">{{ ing.label }}</td>
                    <!-- price -->
                    <td class="result-table__col result-table__col--input">
                      <price-input
                        :currency="currency"
                        :max="ing.price.max"
                        :measure="ing.measure"
                        :min="ing.price.min"
                        :purchase="ing.purchase"
                        :step="ing.price.step"
                        len="2"
                        title="Стоимость сырья"
                        v-if="ing.price"
                        v-model.number="ingredientPrices[ing.name]"
                      />
                    </td>
                    <!-- amount -->
                    <td class="result-table__col result-table__col--input">
                <span v-if="ing.value">
                  <span
                    class="nobr"
                    v-if="ing.name === 'pallet'"
                  >
                    {{ ingredientValues[ing.name] }}
                    <span class="measure">{{ ing.measure }}</span>
                  </span>
                  <price-input
                    :max="ing.value.max"
                    :measure="ing.measure"
                    :min="ing.value.min"
                    :step="ing.value.step"
                    len="1"
                    v-else
                    v-model.number="ingredientValues[ing.name]"
                  />
                </span>
                    </td>
                    <!-- total price -->
                    <td class="result-table__col result-table__col--sq">
                      <price :currency="currency" :num="ing.sqPrice" size="sm" />
                    </td>
                    <!-- total amount -->
                    <td class="result-table__col result-table__col--result">
                      <span class="nobr">{{ priceDisplay(ing.amount / ing.purchase.multiplier) }}<span class="measure">{{ ing.purchase.measure }}</span></span>
                    </td>
                    <!-- sum -->
                    <td class="result-table__col result-table__col--result">
                      <price :currency="currency" :num="ing.sum" size="sm" />
                    </td>
                  </tr>
                  <tr>
                    <td class="result-table__col result-table__col--left result-table__col--label">{{ $t('message.electricity') }}</td>
                    <td class="result-table__col result-table__col--input">
                      <price-input
                        :currency="currency"
                        :max="localEnergyTariff.max"
                        :min="localEnergyTariff.min"
                        :step="localEnergyTariff.step"
                        len="2"
                        :measure="$t('measure.kW')"
                        v-model.number="realEnergyTariff"
                      />
                    </td>
                    <td class="result-table__col result-table__col--input">
                      <span class="nobr">{{ realEnergy }}<span class="measure">{{ $t('measure.kW') }}</span></span>
                      <!--                            <price-input-->
                      <!--                              :currency="currency"-->
                      <!--                              len="1"-->
                      <!--                              :max="line.energy_for_cube * 2"-->
                      <!--                              :min="line.energy_for_cube"-->
                      <!--                              measure="кВ"-->
                      <!--                              step="0.1"-->
                      <!--                              v-model.number="realEnergy"-->
                      <!--                            />-->
                    </td>
                    <td class="result-table__col result-table__col--sq">
                      <price :currency="currency" :num="energyPerSq" size="sm" />
                    </td>
                    <td class="result-table__col result-table__col--result">&nbsp;</td>
                    <td class="result-table__col result-table__col--result">
                      <price :currency="currency" :num="perCapability(energyPerSq)" size="sm" />
                    </td>
                  </tr>
                  <tr>
                    <td class="result-table__col result-table__col--left result-table__col--label">{{ $t('message.rent') }}</td>
                    <td class="result-table__col result-table__col--input">
                      <price-input
                        :currency="currency"
                        :max="localRent.max"
                        :min="localRent.min"
                        :step="localRent.step"
                        len="2"
                        :measure="$t('measure.m2')"
                        v-model.number="realRent"
                      />
                    </td>
                    <td class="result-table__col result-table__col--input">
                      <price-input
                        :min="line.area"
                        len="1"
                        max="1000"
                        :measure="$t('measure.m2')"
                        step="10"
                        v-model.number="realArea"
                      />
                    </td>
                    <td class="result-table__col result-table__col--sq">
                      <price :currency="currency" :num="rentPerSq" size="sm" />
                    </td>
                    <td class="result-table__col result-table__col--result">&nbsp;</td>
                    <td class="result-table__col result-table__col--result">
                      <price :currency="currency" :num="perCapability(rentPerSq)" size="sm" />
                    </td>
                  </tr>
                  <tr>
                    <td class="result-table__col result-table__col--left result-table__col--label">{{ $t('message.pieceRate') }}</td>
                    <td class="result-table__col result-table__col--input">
                      <price-input
                        :currency="currency"
                        :max="localTariff.max"
                        :min="localTariff.min"
                        :step="localTariff.step"
                        len="2"
                        :measure="$t('measure.m3')"
                        v-model.number="realTariff"
                      />
                    </td>
                    <td class="result-table__col result-table__col--input">
                      &nbsp;
                    </td>
                    <td class="result-table__col result-table__col--sq">
                      <price :currency="currency" :num="realTariff" id="tooltip-employers-sq" />
                      <b-popover placement="top" target="tooltip-employers-sq" triggers="hover">
                        {{ $t('message.totalSpendsForSalary') }}{{ $t('measure.Nm3', [1]) }}
                      </b-popover>
                    </td>
                    <td class="result-table__col result-table__col--result">&nbsp;</td>
                    <td class="result-table__col result-table__col--result">
                      <price :currency="currency" :num="perCapability(realTariff)" size="sm" />
                    </td>
                  </tr>
                  <tr>
                    <td class="result-table__col result-table__col--sum" colspan="4">
                      {{ $t('message.costPriceOf', [$t('measure.Nm3', [1])]) }}:
                      <price :currency="currency" :num="cost" size="sm" />
                    </td>
                    <td class="result-table__col result-table__col--result result-table__col--sum" colspan="2">
                      <price :currency="currency" :num="perCapability(cost)" hideChange size="sm" />
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="mt-6">
              <h2 class="h3">{{ $t('message.helpHeader') }}</h2>
              <base-video
                class="my-4 w-75"
                thumbnail
                preview="https://i.ytimg.com/vi_webp/HSbOJ_PeeqQ/maxresdefault.webp"
                lightbox
                src="https://youtu.be/HSbOJ_PeeqQ"
                title="Считаем рентабельность оборудования для газобетона в 2020 году"
                duration="3:02"
              />
              <p>{{ $t('message.helpText') }}</p>

              <h2 class="h3">{{ $t('message.helpHeader1') }}</h2>
              <p>{{ $t('message.helpText1') }}</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <base-lightbox />
  </div>
</template>

<script>
  import {
    __,
    add,
    always,
    applySpec,
    clone,
    compose,
    equals,
    evolve,
    find,
    head,
    identity,
    ifElse,
    isNil,
    map,
    mapObjIndexed,
    multiply,
    pathOr,
    prop,
    propEq,
    propOr,
    range,
    subtract,
    sum,
    values,
  } from 'ramda'
  import {mapActions, mapGetters, mapState} from 'vuex';
  import {divideTo, employersFrom, energyForSqFrom, optionSpec, resultPageSpec} from "@/lib/utils";
  // Components
  import CapabilityChooser from "@/components/AerocreteCalculator/CapabilityChooser";
  import PeriodChooser from "@/components/AerocreteCalculator/PeriodChooser";
  import PriceInput from "@/components/SlideInput";
  import Price from "@/components/Price";
  import ButtonSavePDF from "@/components/ButtonSavePDF";
  import ButtonReset from "@/components/ButtonReset";
  import BaseVideo from "@/components/BaseVideo";
  import BaseLightbox from "@/components/BaseLightbox";
  // Mixins
  import priceFormatter from "@/mixins/priceFormatter";
  import declOfNum from "@/mixins/declOfNum";
  import exportReportPDF from "@/mixins/exportReportPDF";

  // eslint-disable-next-line no-unused-vars
  const log = (t) => {
    console.log(t);
    return t;
  };


  export default {
    name: "AerocreteCalculator",
    components: {
      BaseLightbox,
      BaseVideo,
      CapabilityChooser,
      PeriodChooser,
      ButtonSavePDF,
      ButtonReset,
      Price,
      PriceInput
    },
    mixins: [
      priceFormatter,
      declOfNum,
      exportReportPDF
    ],
    props: {
      showChart: {
        type: Boolean,
        default: false
      },
      showRecipe: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        ingredientPrices: {},
        ingredientValues: {},
        ingredientOptions: {},

        period: 30,
        workerSalary: 15000,

        realCapability: 0,

        realEnergyTariff: 4,
        realRent: 0,
        realTariff: 0,

        realEnergy: 0,
        realPrice: 0,
        realArea: 0,
        equipmentPrice: 0
      };
    },
    watch: {
      localIngredientOptions: {
        immediate: true,
        handler(opt) {
          this.ingredientOptions = clone(opt);
        }
      },
      localIngredientPrices: {
        immediate: true,
        handler(ings) {
          this.ingredientPrices = clone(ings);
        }
      },
      localEnergyTariff: {
        immediate: true,
        handler(energy) {
          this.realEnergyTariff = energy.value;
        }
      },
      localRent: {
        immediate: true,
        handler(rent) {
          this.realRent = rent.value;
        }
      },
      localTariff: {
        immediate: true,
        handler(tariff) {
          this.realTariff = tariff.value;
        }
      },
      localPrice: {
        immediate: true,
        handler(price) {
          this.realPrice = price.value;
        }
      },
      line: {
        immediate: true,
        handler(line) {
          if (isNil(line)) return;

          this.equipmentPrice = ifElse(
            isNil, always(0),
            compose(
              prop('price'),
              find(propEq('id', line.id))
            )
          )(this.linePrices);

          this.realCapability = line.capability;
          this.realArea = line.area;
          this.realEnergy = energyForSqFrom(this.line);
        }
      },
      recipe: {
        immediate: true,
        handler(recipe) {
          if (isNil(recipe)) return;

          this.ingredientValues = mapObjIndexed(pathOr(0, ['value', 'value']), recipe.index);
        }
      }
    },
    computed: {
      /**
       * mapping state variables
       **/
      ...mapState('desktop', [
        'recipes', 'linePrices', 'currentLine', 'currentUser', 'currencies'
      ]),
      ...mapGetters('desktop', [
        'currency', 'hideChange', 'currencySelect', 'lineSelectOptions', 'localIngredients',
        'line', 'recipe', 'localPrice', 'localEnergyTariff', 'localRent', 'localTariff', 'localIngredientPrices', 'localIngredientOptions'
      ]),

      /**
       * Вычисляет производительность
       * линии за расчетный период
       * Требуется для дальнейших расчетов
       * @returns {Number}
       */
      capability() {
        return ifElse(
          isNil, always(0), // Проверка на отсутствие выбранной линии
          multiply(this.period)
        )(this.realCapability)
      },

      /**
       * Вычисляет производительность
       * линии за месяц
       * Требуется для дальнейших расчетов
       * @returns {Number}
       */
      capabilityPerMonth() {
        return ifElse(
          isNil, always(0), // Проверка на отсутствие выбранной линии
          multiply(30)
        )(this.realCapability)
      },

      /**
       * Вычисляет стоимость Аренды
       * @returns {object}
       */
      rentPerSq() {
        return this.calcRent(
          this.realRent, this.realArea, this.capabilityPerMonth
        );
      },

      /**
       * Вычисляет Фонд оплаты труда
       * @returns {object}
       */
      salaryPerSq() {
        return this.calcSalary(
          this.workerSalary, employersFrom(this.line), this.capabilityPerMonth
        );
      },

      /**
       * Вычисляет Затраты на электроэнергию
       * @returns {object}
       */
      energyPerSq() {
        return this.calcEnergy(
          this.realEnergyTariff, this.realEnergy
        );
      },

      breakeven() {
        return compose(
          // filter(lt(0)),
          map(compose(
            (num) => num.toFixed(2),
            subtract(this.realPrice),
            (capability) => {
              return this.calcCost(
                this.ingredientPrices,
                this.ingredientValues,
                this.realTariff, //this.calcSalary(this.workerSalary, employersFrom(this.line), multiply(capability, 30)),
                this.calcRent(this.realRent, this.realArea, multiply(capability, 30)),
                this.calcEnergy(this.realEnergyTariff, energyForSqFrom(this.line))
              )
            }
          ))
        )(range(1, add(this.line.capability, 1)));
      },

      /**
       * Вычисляет Затраты на производство
       * одного кубометра газобетона
       * @returns {object}
       */
      cost() {
        return this.calcCost(this.ingredientPrices, this.ingredientValues, this.realTariff, this.rentPerSq, this.energyPerSq)
      },

      /**
       * Вычисляет Прибыль
       * за кубометр
       * @returns {Number}
       */
      profit() {
        return compose(
          subtract(__, parseFloat(this.cost)),
          parseFloat
        )(this.realPrice)
      },

      /**
       *
       * @returns {object}
       * {
       *   sum: Number
       *   ingredients: [
       *     name: String,
       *     label: String,
       *     measure: String,
       *     sqPrice: Number,
       *     amount: Number,
       *     price: Number
       *   ]
       * }
       */
      result() {
        const prices = this.ingredientPrices;
        const opt = this.ingredientOptions;
        const val = this.ingredientValues;

        const ingredients = (cap) => {
          const amount = (ing) => multiply(cap, prop(ing.name, val));
          const sum = (ing) => compose(multiply(prop(ing.name, prices)), amount)(ing);
          return map(
            applySpec({
              name: prop('name'),
              label: prop('label'),
              measure: prop('measure'),
              value: (ing) => prop(ing.name, opt),
              price: (ing) => compose(
                evolve({
                  value: always(prop(ing.name, prices))
                }),
                prop('price')
              )(ing),
              purchase: prop('purchase'),
              sqPrice: (ing) => multiply(prop(ing.name, prices), prop(ing.name, val)),
              amount: amount,
              sum: sum
            })
          )(this.localIngredients);
        };
        return compose(
          resultPageSpec,
          ingredients
        )(this.capability)
      }
    },
    methods: {
      ...mapActions('desktop', [
        'selectCurrency',
        'selectLine'
      ]),
      reset() {
        this.$store.dispatch('desktop/fetch');
      },
      toPDF() {
        this.savePDF({
          line: this.line,
          period: this.period,
          capability: this.realCapability,
          days: this.declOfNum(this.period, ['день', 'дня', 'дней']),
          ingredients: this.result.ingredients,
          price: this.priceDisplay(this.realPrice, true),
          profit: this.priceDisplay(this.profit, this.hideChange),
          fullProfit: this.priceDisplay(this.profit * this.capability, true),
          sum: this.priceDisplay(this.perCapability(this.cost), this.hideChange),
          cost: this.priceDisplay(this.cost, this.hideChange),
          currency: this.currency.symbol,
          rent: {
            price: this.priceDisplay(this.realRent, this.hideChange),
            value: this.realArea,
            sqPrice: this.priceDisplay(this.rentPerSq, this.hideChange),
            sum: this.priceDisplay(this.perCapability(this.rentPerSq), this.hideChange)
          },
          tariff: {
            price: this.priceDisplay(this.realTariff, this.hideChange),
            sqPrice: this.priceDisplay(this.realTariff, this.hideChange),
            sum: this.priceDisplay(this.perCapability(this.realTariff), this.hideChange)
          },
          energy: {
            price: this.priceDisplay(this.realEnergyTariff, this.hideChange),
            value: this.realEnergy,
            sqPrice: this.priceDisplay(this.energyPerSq, this.hideChange),
            amount: this.priceDisplay(this.perCapability(this.realEnergy), this.hideChange),
            sum: this.priceDisplay(this.perCapability(this.energyPerSq), this.hideChange)
          }
        });
      },
      /**
       * Значение при текущей производительности
       * @returns {Number}
       */
      perCapability(val) {
        return multiply(val, this.capability);
      },

      /**
       * Вычисляет стоимость Аренды
       * за кубометр
       * @returns {Number}
       */
      calcRent: function (rentPerMonth, area, capabilityPerMonth) {
        return compose(
          multiply(area),
          ifElse(equals(Infinity), always(0), identity),
          divideTo(capabilityPerMonth),
          parseFloat
        )(rentPerMonth)
      },

      /**
       * Вычисляет Фонд оплаты труда
       * за кубометр
       * @returns {Number}
       */
      calcSalary(salary, employers, capabilityPerMonth) {
        return compose(
          divideTo(capabilityPerMonth),
          multiply(employers),
          parseFloat
        )(salary)
      },

      /**
       * Вычисляет Затраты на электроэнергию
       * за кубометр
       * @returns {Number}
       */
      calcEnergy(realEnergyTariff, energyPerSQ) {
        return compose(
          multiply(energyPerSQ),
          parseFloat
        )(realEnergyTariff)
      },

      /**
       * Вычисляет Затраты на производство
       * одного кубометра газобетона
       * @returns {object}
       */
      calcCost(ingredientPrices, ingredientValues, salaryPerSq, rentPerSq, energyPerSq) {
        return compose(
          add(salaryPerSq),
          add(rentPerSq),
          add(energyPerSq),
          sum,
          values,
          mapObjIndexed((n, name, prices) => {
            let price = prop(name, prices);
            return multiply(price, propOr(NaN, name, ingredientValues));
          })
        )(ingredientPrices);
      }

    },
    async mounted() {
      await this.$store.dispatch('desktop/getCountry');
      await this.$store.dispatch('desktop/getCurrency');
      await this.$store.dispatch('desktop/whoAmI');
      await this.$store.dispatch('desktop/fetch');
    },
    filters: {
      toOptions(arr) {
        return compose(
          map(optionSpec)
        )(arr);
      },
      first(arr) {
        return head(arr)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .asm-calculator {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;

    @media screen and (max-width: 800px) {
      &__result {
        overflow-x: auto;
        overflow-y: hidden;
        max-width: 100%;
      }

      &-table {
        min-width: 550px;
      }
    }


    &__headline {
      font-size: 1.75em;
    }

    &__header {
      border-bottom: 1px solid #ebebeb;
      padding: 0.5em;
    }

    &__column {
      display: flex;
      flex-flow: column nowrap;
      align-items: stretch;
    }

    &__production-line {
      margin: 0 0 auto;
    }

    &__line-link {
      line-height: 38px;
      display: inline-block;
    }
  }

  .nobr {
    white-space: nowrap;
  }

  .result-table {
    width: 100%;
    margin-top: -1px;
    table-layout: fixed;

    &__gap {
      width: 1em;
      border-bottom: none;
      border-top: 1px solid #A3A3A3;
    }

    &__head-col {
      padding: 0.5em 0;
      font-size: 1em;
      font-weight: 500;
      border-top: 1px solid #A3A3A3;
      border-bottom: 2px solid #A3A3A3;

      &--result {
        padding: 0.5em 0.5em 0.5em 1em;
        background-color: #E5E5E5;
      }

      &--super {
        font-size: 1.125em;
        padding: 0.35em 0 //0.75em;
      }
    }

    &__col {
      padding: 0.5em 0.5em;
      font-size: 14px;
      line-height: 24px;
      border-bottom: 1px solid #a3a3a3;
      border-right: 1px solid #EBEBEB;


      &--input {
      }

      &--label {
        text-align: left;
        font-weight: 300;
      }

      &--right {
        border-right: none;
      }

      &--left {
        width: 9em;
      }

      &--recipe {
        width: 6em;
      }

      &--center {
        text-align: center;
      }

      &:last-child,
      &--sq,
      &--result,
      &--sum,
      &--input {
        text-align: right;
      }

      &--result {
        background-color: #E5E5E5;
        border-bottom: 1px solid #a3a3a3;
        padding: 0.5em 1em 0.5em 0.5em;
      }

      &--left {
        padding: 0.5em 0.5em 0.5em 1em;
      }

      &--sum,
      &--sq {
        padding: 0.5em 1em 0.5em 0.5em;
      }

      &--label-result-num,
      &--label-result {
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 32px;
        border-top: 2px solid #A3A3A3;
        border-right: none;
      }

      &--label-result-num {
        text-align: right;
      }

      &--sum {
        border-top: 2px solid #A3A3A3;
        font-weight: bold;
        padding: 16px 1em;
      }
    }

    tr:first-child .result-table__head-col {
      border-top: none;
    }

    tr:last-child .result-table__col {
      border-bottom: none;
    }
  }

  .measure {
    display: inline-block;
    vertical-align: baseline;
    user-select: none;
    font-size: 0.8rem;
    line-height: 1.5rem;
    color: #555555;
    margin-left: 0.5em;
    width: 1em;
    white-space: nowrap;
    text-align: left;
  }
</style>
